import type { MotionScale } from '@/theme/types'

export const motion: MotionScale = {
  duration: {
    fast: 120,
    normal: 200,
    slow: 280,
  },
  easing: {
    standard: 'cubic-bezier(0.2, 0, 0, 1)',
    decelerate: 'cubic-bezier(0, 0, 0, 1)',
    accelerate: 'cubic-bezier(0.3, 0, 1, 1)',
  },
}

